import CarpetCalculator from "./CarpetCalculator";

function App() {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <CarpetCalculator />
    </div>
  );
}

export default App;
